import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, TemplateRef, ViewChild, } from "@angular/core";
import { UpgradeModule } from "@angular/upgrade/static";
import { ModalService, NotificationService } from "@tva/ng-migration/uicomponents";
import { AuthenticationService } from "@tva/ng-migration/core";
import { CourseManagementService } from "@tva/ng-migration/course-management/services/course-management.service";
import { MatDialog } from "@angular/material/dialog";
import { take } from "rxjs/operators";

const uiGridConstants = {
  ASC: "",
};


@Component({
  selector: "app-course-management-search-results",
  templateUrl: "./course-management-search-results.component.html",
  styleUrls: ["./course-management-search-results.component.scss"],
})
export class CourseManagementSearchResultsComponent
  implements OnInit, OnChanges {
  gridApi;
  searchedFilters: any = {};
  gridOptions;
  isActive = false;

  @Input() results;

  @Output() updateSearch = new EventEmitter<any>();

  @ViewChild('deactivateCourseTemplate', { read: TemplateRef }) deactivateCourseTemplate: TemplateRef<any>;
  @ViewChild('reactivateCourseTemplate', { read: TemplateRef }) reactivateCourseTemplate: TemplateRef<any>;


  constructor(
    private dialog: MatDialog,
    private notification: NotificationService,
    private courseManagementService: CourseManagementService
  ) {
  }

  private setGridOptions(): void {
    this.gridOptions = {
      data: null,
      enableFiltering: true,
      exporterMenuCsv: true,
      exporterMenuPdf: false,
      rowHeight: 40,
      paginationPageSizes: [25, 50, 75],
      paginationPageSize: 25,
      enableGridMenu: true,
      exporterCsvFilename: "courses.csv",
      columnDefs: [
        {
          field: "courseCode",
          displayName: "Course code",
          width: 130,
          sort: { direction: uiGridConstants.ASC },
          cellTemplate:
            "<div class='ui-grid-cell-contents ui-grid-link'> <span ui-sref='courseManagement.editCourse({code:row.entity[col.field]})'>{{row.entity[col.field]}}</span> <div>",
        },
        {
          field: "courseContentType.name",
          displayName: "Course Content Type",
          width: 180,
        },
        { field: "defaultCredits", displayName: "Default Credits", width: 170 },
        { field: "courseName", displayName: "Course Name", width: 130 },
        { field: "courseGrade.name", displayName: "Course Grade", width: 130 },
        { field: "courseLevel.name", displayName: "Course Level", width: 130 },
        { field: "courseLength.name",displayName: "Course Length",width: 150 },
        { field: 'courseSubject.name', displayName: 'Course Subject', width: 150},
        {field: "courseTypeObject.name", displayName: "Course Type", width: 130},
        {
          field: "courseVendorsText",
          displayName: "Content Vendor",
          width: 150,
        },
        { field: "nextCoursesText", displayName: "Next Course", width: 130 },
        {
          field: "specifiedStatesText",
          displayName: "Specified States",
          width: 150,
        },
        {
          field: "createDate",
          displayName: "Created Date",
          width: 130,
          cellTemplate:
            "<div class='ui-grid-cell-contents'>{{row.entity[col.field]| date: 'MM/dd/yyyy' }}</div>",
        },
        { field: "createdByName", displayName: "Created By", width: 130 },
        {
          field: "modifyDate",
          displayName: "Modified Date",
          width: 120,
          cellTemplate:
            "<div class='ui-grid-cell-contents'>{{row.entity[col.field]| date: 'MM/dd/yyyy' }}</div>",
        },
        { field: "modifiedByName", displayName: "Modified By", width: 120 },
      ],
      onRegisterApi: (gridApi) => {
        this.gridApi = gridApi;
      },
      gridMenuCustomItems: [
        {
          title: "Reactivate Course",
          action: () => {
            const courses = this.gridApi.selection
              .getSelectedRows()
              .map(({ courseCode }) => {
                return { courseCode };
              });

            this.dialog.open(this.reactivateCourseTemplate).afterClosed().pipe(take(1)).subscribe((closedWithYes) => {
              if (!closedWithYes)
                return

              this.courseManagementService.reactivateCourses(courses).subscribe(() => {
                this.updateSearch.emit();
                this.notification.notifySuccess();
              }, ({ error: { _errors } }) => {
                this.notification.showErrorMessage(_errors[0]);
              });
            });
          },
          order: 1,
          shown: () =>
            this.gridApi.selection.getSelectedRows().length > 0 && this.searchIsInactive(),
        },
        {
          title: "Inactivate Course",
          action: () => {
            const courses = this.gridApi.selection
              .getSelectedRows()
              .map(({ courseCode }) => {
                return { courseCode };
              });
            this.dialog.open(this.deactivateCourseTemplate).afterClosed().pipe(take(1)).subscribe((closedWithYes) => {
              if (!closedWithYes)
                return

              this.courseManagementService.deactivateCourses(courses).subscribe(() => {
                this.updateSearch.emit();
                this.notification.notifySuccess();
              }, ({ error: { _errors } }) => {
                this.notification.showErrorMessage(_errors[0], _errors[1]);
              });
            });
          },
          order: 1,
          shown: () =>
            this.gridApi.selection.getSelectedRows().length > 0 &&
            this.searchIsActive(),
        },
      ],
    };
  }

  ngOnInit(): void {
    this.setGridOptions();
  }

  notify(): void {
    this.notification.notifySuccess();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.results.currentValue) {
      this.gridOptions.data = changes.results.currentValue;
      if (this.gridOptions.data.length) {
        this.isActive = this.gridOptions.data[0].status === 1;
      }
    }
  }

  private searchIsActive(): boolean {
    return this.isActive;
  }

  private searchIsInactive(): boolean {
    return !this.isActive;
  }
}
